module.exports = __webpack_public_path__ + "img/symbol_arrow1green.1e9ede16.png";